import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { limitsAndPayoutsStore } from '../../../store/limitsAndPayoutsStore';
import { OWNER_T_KEYS } from '../../../enums/cardOwner';
import { NON_STOP_MATCH } from '../../../enums/constants';

const LimitAndPayouts = observer(() => {
  const t = useTranslation();
  const { currencyCode } = userInfoStore;
  const { limitsPayouts } = limitsAndPayoutsStore;
  const { limits } = gameConfigStore;
  return (
    <div className='limit-payouts-holder'>
      <div className='limit-payouts-row head'>
        <div className='limit-payouts-column left'>{t(NON_STOP_MATCH)}</div>
        <div className='limit-payouts-column right'>
          {currencyCode} {limits.minBet} - {limits.maxBet}
        </div>
      </div>
      {limitsPayouts.map(({ marketType, payout }) => {
        return (
          <div key={marketType} className='limit-payouts-row'>
            <div className='limit-payouts-column name'>{t(OWNER_T_KEYS[marketType])}</div>
            <div className='limit-payouts-column number'>{payout}</div>
          </div>
        );
      })}
    </div>
  );
});

export default LimitAndPayouts;
